"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var enquiryFormDataTransformerGQL = {
    to: function (data) {
        var _a, _b, _c, _d, _e;
        var formData = {
            nameInfo: {
                firstName: data.firstName || '',
                lastName: data.lastName || '',
                salutation: data.salutation || 1,
                nationalityId: data.nationalityId || '',
            },
            contactInfo: {
                phone: data.phone || '',
                email: data.email || '',
                areaCode: data.areaCode || '',
                identificationNumber: data.identificationNumber,
                preferredContactMethod: data.preferredContactMethod || '',
            },
            regionDistrict: {
                region: data.region || '',
                district: data.district || '',
            },
            address: data.address || '',
            cityDealer: {
                citySelect: data.citySelect || '',
                dealerSelect: data.dealerSelect || '',
            },
            provinceRegionDistrict: {
                region: data.region || '',
                district: data.district || '',
                province: data.province || '',
            },
            cityDistrictDealer: {
                citySelect: data.citySelect || '',
                cityDistrict: data.cityDistrict || '',
                dealerSelect: data.dealerSelect || '',
            },
            regionDealer: {
                regionSelect: data.regionSelect || '',
                dealerSelect: data.dealerSelect || '',
            },
            identificationNumberByType: {
                identificationType: data.identificationType || '',
                identificationNumber: data.identificationNumber || '',
            },
            location: {
                city: data.city || '',
                dealer: data.dealer || '',
                postCodeAutocomplete: data.postCodeAutocomplete || '',
            },
            termsAndConditions: (_a = data.termsAndConditions, (_a !== null && _a !== void 0 ? _a : false)),
            legalDisclaimer: (_b = data.legalDisclaimer, (_b !== null && _b !== void 0 ? _b : false)),
            privacyPolicy: (_c = data.privacyPolicy, (_c !== null && _c !== void 0 ? _c : false)),
            marketingInformation: (_d = data.marketingInformation, (_d !== null && _d !== void 0 ? _d : false)),
            captchaToken: data.captchaToken,
            appointment: {
                dealerSelect: data.dealerSelect || '',
                salesConsultant: data.salesConsultant || '',
                preferredDate: data.preferredDate || '',
                preferredTime: data.preferredTime || '',
                purchaseTime: data.purchaseTime || '',
                comments: data.comments || '',
                identificationNumberRut: (_e = data.identificationNumberRut, (_e !== null && _e !== void 0 ? _e : '')),
            },
            housing: {
                housingDepartment: data.housingDepartment || '',
                housingProvince: data.housingProvince || '',
                housingDistrict: data.housingDistrict || '',
                housingStreet: data.housingStreet || '',
            },
            tradeIn: {
                colour: data.tradeIn.colour || '',
                make: data.tradeIn.make || '',
                model: data.tradeIn.model || '',
                variant: data.tradeIn.variant || '',
                year: data.tradeIn.year || '',
                mileage: data.tradeIn.mileage || '',
                tradeInCheckbox: data.tradeIn.tradeInCheckbox || false,
            },
            customerTypeSwitch: {
                companyName: data.customerTypeSwitch.companyName || '',
                customerType: data.customerTypeSwitch.customerType || '',
            },
            tradeInSelect: data.tradeInSelect || '',
            singpassInfo: {
                fullNamePerNRIC: data.singpassInfo.fullNamePerNRIC,
                identity: data.singpassInfo.identity,
                occupation: data.singpassInfo.occupation,
                occupationType: data.singpassInfo.occupationType,
                dateOfBirth: data.singpassInfo.dateOfBirth,
                email: data.singpassInfo.email,
                NRIC: data.singpassInfo.NRIC,
                gender: data.singpassInfo.gender,
                nationalityId: data.singpassInfo.nationalityId,
                phone: data.singpassInfo.phone,
                telephoneNo: data.singpassInfo.telephoneNo,
                block: data.singpassInfo.block,
                unitNo: data.singpassInfo.unitNo,
                country: data.singpassInfo.country,
                model: data.singpassInfo.model,
                aliasName: data.singpassInfo.aliasName,
                hanyuPinyinAliasName: data.singpassInfo.hanyuPinyinAliasName,
                drivingLicenseDate: data.singpassInfo.drivingLicenseDate,
                streetName: data.singpassInfo.streetName,
                buildingName: data.singpassInfo.buildingName,
                postalCode: data.singpassInfo.postalCode,
                variant: data.singpassInfo.variant,
                hanyuPinyinName: data.singpassInfo.hanyuPinyinName,
                maritalStatus: data.singpassInfo.maritalStatus,
                marriedName: data.singpassInfo.marriedName,
            },
            customerTypeInfo: {
                customerType: data.customerTypeInfo.customerType || '',
            },
        };
        if (data.district) {
            formData.location.district = data.district;
        }
        if (data.identificationType) {
            formData.contactInfo.identificationType = data.identificationType;
        }
        if (data.salesConsultant) {
            formData.dealerConsultant.dealerSelect = data.dealerSelect;
            formData.dealerConsultant.salesConsultant = data.salesConsultant;
        }
        return formData;
    },
    from: function (data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14;
        var formData = {
            firstName: (_a = data.nameInfo) === null || _a === void 0 ? void 0 : _a.firstName,
            lastName: (_b = data.nameInfo) === null || _b === void 0 ? void 0 : _b.lastName,
            phone: (_c = data.contactInfo) === null || _c === void 0 ? void 0 : _c.phone,
            email: (_d = data.contactInfo) === null || _d === void 0 ? void 0 : _d.email,
            dealerSelect: ((_e = data.appointment) === null || _e === void 0 ? void 0 : _e.dealerSelect) || ((_f = data.cityDealer) === null || _f === void 0 ? void 0 : _f.dealerSelect) || ((_g = data.postCodeDealer) === null || _g === void 0 ? void 0 : _g.dealerSelect) || ((_h = data.regionDealer) === null || _h === void 0 ? void 0 : _h.dealerSelect) ||
                data.dealerSelect,
            salesConsultant: (_j = data.appointment) === null || _j === void 0 ? void 0 : _j.salesConsultant,
            termsAndConditions: data.termsAndConditions,
            legalDisclaimer: data.legalDisclaimer,
            privacyPolicy: data.privacyPolicy,
            marketingCommercialOptins: (_l = (_k = data) === null || _k === void 0 ? void 0 : _k.marketingCommercialOptins) === null || _l === void 0 ? void 0 : _l.length,
            captchaToken: data.captchaToken,
            identificationType: (_m = data.identificationNumberByType) === null || _m === void 0 ? void 0 : _m.identificationType,
            identificationNumber: (_o = data.identificationNumberByType) === null || _o === void 0 ? void 0 : _o.identificationNumber,
            identificationNumberRut: data.identificationNumberRut,
            citySelect: (_p = data.cityDealer) === null || _p === void 0 ? void 0 : _p.citySelect,
            postCodeAutocomplete: (_q = data.postCodeDealer) === null || _q === void 0 ? void 0 : _q.postCodeAutocomplete,
            companyName: (_r = data.customerTypeSwitch) === null || _r === void 0 ? void 0 : _r.companyName,
            customerType: (_s = data.customerTypeSwitch) === null || _s === void 0 ? void 0 : _s.customerType,
            regionSelect: (_t = data.regionDealer) === null || _t === void 0 ? void 0 : _t.regionSelect,
            tradeInSelect: data.tradeInSelect,
        };
        if ((_u = data.appointment) === null || _u === void 0 ? void 0 : _u.preferredDate) {
            formData.preferredDate = data.appointment.preferredDate;
        }
        if ((_v = data.contactInfo) === null || _v === void 0 ? void 0 : _v.preferredContactMethod) {
            formData.preferredContactMethod = data.contactInfo.preferredContactMethod;
        }
        if ((_w = data.appointment) === null || _w === void 0 ? void 0 : _w.preferredTime) {
            formData.preferredTime = data.appointment.preferredTime;
        }
        if ((_x = data.appointment) === null || _x === void 0 ? void 0 : _x.purchaseTime) {
            formData.purchaseTime = data.appointment.purchaseTime;
        }
        if ((_y = data.appointment) === null || _y === void 0 ? void 0 : _y.comments) {
            formData.comments = data.appointment.comments;
        }
        if ((_z = data.appointment) === null || _z === void 0 ? void 0 : _z.salesConsultant) {
            formData.salesConsultant = data.appointment.salesConsultant;
        }
        if ((_0 = data.nameInfo) === null || _0 === void 0 ? void 0 : _0.salutation) {
            formData.salutation = data.nameInfo.salutation;
        }
        if ((_1 = data.nameInfo) === null || _1 === void 0 ? void 0 : _1.nationalityId) {
            formData.nationalityId = data.nameInfo.nationalityId;
        }
        if ((_2 = data.contactInfo) === null || _2 === void 0 ? void 0 : _2.areaCode) {
            formData.areaCode = data.contactInfo.areaCode;
        }
        if ((_3 = data.contactInfo) === null || _3 === void 0 ? void 0 : _3.identificationType) {
            formData.identificationType = data.contactInfo.identificationType;
        }
        if ((_4 = data.appointment) === null || _4 === void 0 ? void 0 : _4.identificationNumberRut) {
            formData.identificationNumberRut = data.appointment.identificationNumberRut;
        }
        if ((_5 = data.location) === null || _5 === void 0 ? void 0 : _5.city) {
            formData.city = data.location.city;
        }
        if ((_6 = data.location) === null || _6 === void 0 ? void 0 : _6.district) {
            formData.district = data.location.district;
        }
        if ((_7 = data.appointment) === null || _7 === void 0 ? void 0 : _7.postCodeAutocomplete) {
            formData.postCodeAutocomplete = data.appointment.postCodeAutocomplete;
        }
        if ((_8 = data.contactInfo) === null || _8 === void 0 ? void 0 : _8.identificationNumber) {
            formData.identificationNumber = data.contactInfo.identificationNumber;
        }
        if (data.marketingInformation) {
            formData.marketingInformation = data.marketingInformation;
        }
        if (data.housing) {
            formData.housingDepartment = data.housing.housingDepartment || '';
            formData.housingProvince = data.housing.housingProvince || '';
            formData.housingDistrict = data.housing.housingDistrict || '';
            formData.housingStreet = data.housing.housingStreet || '';
        }
        if ((_9 = data.identificationNumberByType) === null || _9 === void 0 ? void 0 : _9.identificationNumber) {
            formData.identificationNumber = data.identificationNumberByType.identificationNumber;
        }
        if ((_10 = data.tradeIn) === null || _10 === void 0 ? void 0 : _10.tradeInCheckbox) {
            formData.colour = data.tradeIn.colour;
            formData.make = data.tradeIn.make;
            formData.model = data.tradeIn.model;
            formData.variant = data.tradeIn.variant;
            formData.year = data.tradeIn.year;
            formData.mileage = data.tradeIn.mileage;
            formData.tradeInCheckbox = data.tradeIn.tradeInCheckbox;
        }
        if (data.regionDistrict) {
            formData.region = data.regionDistrict.region;
            formData.district = data.regionDistrict.district;
        }
        if (data.provinceRegionDistrict) {
            formData.region = data.provinceRegionDistrict.region;
            formData.district = data.provinceRegionDistrict.district;
            formData.province = data.provinceRegionDistrict.province;
        }
        if (data.cityDistrictDealer) {
            formData.citySelect = data.cityDistrictDealer.citySelect;
            formData.cityDistrict = data.cityDistrictDealer.cityDistrict;
            formData.dealerSelect = data.cityDistrictDealer.dealerSelect;
        }
        if (data.address) {
            formData.address = data.address;
        }
        if ((_11 = data.customerTypeSwitch) === null || _11 === void 0 ? void 0 : _11.companyName) {
            formData.companyName = data.customerTypeSwitch.companyName;
        }
        if ((_12 = data.customerTypeSwitch) === null || _12 === void 0 ? void 0 : _12.customerType) {
            formData.customerType = data.customerTypeSwitch.customerType;
        }
        if ((_13 = data.regionDealer) === null || _13 === void 0 ? void 0 : _13.regionSelect) {
            formData.regionSelect = data.regionDealer.regionSelect;
        }
        if (data.tradeInSelect) {
            formData.tradeInSelect = data.tradeInSelect;
        }
        if (data.dealerConsultant) {
            formData.dealerSelect = data.dealerConsultant.dealerSelect;
            formData.salesConsultant = data.dealerConsultant.salesConsultant;
        }
        if (data.phoneNumberByArea) {
            formData.phone = data.phoneNumberByArea.phone;
            formData.areaCode = data.phoneNumberByArea.areaCode;
        }
        if (data.termsAndConditionsWithConsent) {
            formData.termsAndConditionsWithConsent = data.termsAndConditionsWithConsent;
        }
        if (data.singpassInfo) {
            formData.fullNamePerNRIC = data.singpassInfo.fullNamePerNRIC;
            formData.identity = data.singpassInfo.identity;
            formData.occupation = data.singpassInfo.occupation;
            formData.occupationType = data.singpassInfo.occupationType;
            formData.dateOfBirth = data.singpassInfo.dateOfBirth;
            formData.email = data.singpassInfo.email;
            formData.NRIC = data.singpassInfo.NRIC;
            formData.gender = data.singpassInfo.gender;
            formData.nationalityId = data.singpassInfo.nationalityId;
            formData.phone = data.singpassInfo.phone;
            formData.telephoneNo = data.singpassInfo.telephoneNo;
            formData.block = data.singpassInfo.block;
            formData.unitNo = data.singpassInfo.unitNo;
            formData.country = data.singpassInfo.country;
            formData.model = data.singpassInfo.model;
            formData.aliasName = data.singpassInfo.aliasName;
            formData.hanyuPinyinAliasName = data.singpassInfo.hanyuPinyinAliasName;
            formData.drivingLicenseDate = data.singpassInfo.drivingLicenseDate;
            formData.streetName = data.singpassInfo.streetName;
            formData.buildingName = data.singpassInfo.buildingName;
            formData.postalCode = data.singpassInfo.postalCode;
            formData.variant = data.singpassInfo.variant;
            formData.hanyuPinyinName = data.singpassInfo.hanyuPinyinName;
            formData.maritalStatus = data.singpassInfo.maritalStatus;
            formData.marriedName = data.singpassInfo.marriedName;
        }
        if ((_14 = data.customerTypeInfo) === null || _14 === void 0 ? void 0 : _14.customerType) {
            formData.customerType = data.customerTypeInfo.customerType;
        }
        return formData;
    },
};
exports.default = enquiryFormDataTransformerGQL;
